import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { updateTool } from "./api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { ...rest } = values;
  return {
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };
}

export function useUpdateTool() {
  return useMutation({
    mutationFn: async ({ item, toolId }) => {
      const payload = buildPayload(item);
      const response = await updateTool({ item: payload, toolId });
      return response;
    },
    onSuccess: () => {
      toast.success("Tool Updated Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
